import { useViewMode } from "@/contexts/ViewModeContext";

/* Slim banner shown ONLY to owner accounts so they always know whether
 * they're seeing the owner-bypass experience or the real customer
 * experience. Renders nothing for normal customers. */
export default function OwnerModeBanner() {
  const { isOwner, viewMode, toggleViewMode } = useViewMode();
  if (!isOwner) return null;

  const inCustomerView = viewMode === "customer";
  const bg = inCustomerView ? "bg-amber-500" : "bg-brand-navy";
  const label = inCustomerView ? "CUSTOMER VIEW" : "OWNER MODE";
  const sub = inCustomerView
    ? "Paywall active — Stripe will charge real cards. Toggle off to test for free."
    : "Free testing — projects auto-unlock, Stripe is bypassed.";
  const cta = inCustomerView ? "Switch to Owner mode" : "View as Customer";

  return (
    <div
      data-testid="owner-mode-banner"
      className={`w-full ${bg} text-white text-xs sm:text-[13px]`}
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-1.5 flex items-center justify-between gap-3">
        <div className="flex items-center gap-3 min-w-0">
          <span
            data-testid="owner-mode-pill"
            className="shrink-0 px-2 py-0.5 rounded-full bg-white/15 font-bold tracking-wide uppercase text-[11px]"
          >
            {label}
          </span>
          <span className="hidden sm:inline truncate opacity-95">{sub}</span>
        </div>
        <button
          type="button"
          onClick={toggleViewMode}
          data-testid="owner-mode-toggle"
          className="shrink-0 px-3 h-7 rounded-full bg-white/15 hover:bg-white/25 transition-colors font-semibold text-[12px]"
        >
          {cta}
        </button>
      </div>
    </div>
  );
}
